import {HibuSearchRequest} from '../../search/search-types';

export enum ChatType {
    SINGLE = 'SINGLE',
    MULTI = 'MULTI',
    GENERAL = 'GENERAL',
    SEARCH = 'SEARCH',
}

export enum Role {
    USER = 'user',
    ASSISTANT = 'assistant',
}

export class AiAssistantRequest {
    constructor(
        public message: string,
        public language: string,
        public conversation: AiAssistantMessage[] = [],
        public contextSettings: AiAssistantConversationContext,
        public documents?: AiAssistantContextDocument[],
        public searchRequest?: HibuSearchRequest,
    ) {}
}

export type AiAssistantResponse = {
    documents: AiAssistantContextDocument[];
    answer: string;
};

export enum AiAssistantDocumentSource {
    VECTOR = 'vector',
    WEB = 'web',
}

export type StreamHandlers = {
    onToken: (token: string) => void;
    onMetadata?: (metadata: Record<string, any>) => void;
    onError?: (error: any) => void;
};

// HibuAssistantMessage is what we use to display in the UI and store in the DB
// Inside metadata a list of used documents (from AI-service sources) and the current context (for displaying the correct capability prefix) can be stored
export type HibuAssistantMessage = {
    text: string;
    role: Role;
    metadata?: {[key: string]: any};
};

// AiAssistantMessage we send to and get from the Backend
export class AiAssistantMessage {
    constructor(
        public text: string,
        public role: string,
        public sources: string[],
    ) {}
}

export type AiAssistantConversationContext = {
    enableDocuments: boolean;
    enableWebSearch: boolean;
    tags: string[];
};

export const DEFAULT_ASSISTANT_CONVERSATION_CONTEXT: AiAssistantConversationContext = {
    enableDocuments: true,
    enableWebSearch: false,
    tags: [],
};

export type TotalDuplicates = {
    totalDuplicatesCount: number;
};

export class AiAssistantContextDocument {
    constructor(
        public id: string,
        public title: string,
        public tags: HibuTagValue[],
        public source: AiAssistantDocumentSource = AiAssistantDocumentSource.VECTOR,
        public url?: string,
    ) {}
}

export class AiAssistantSuggestions {
    constructor(public suggestions: string[]) {}
}

export type AiAssistantConversations = Record<string, AiAssistantConversation>;

export type AiAssistantConversation = {
    type: ChatType;
    id: string;
    conversationMessages: HibuAssistantMessage[];
    searchResultsRequests: (HibuSearchRequest | undefined)[];
    suggestions: string[];
    summary: string;
    created: Date;
    totalDuplicatesCount: number;
    context: AiAssistantConversationContext;
};

export class HibuTagValue {
    constructor(
        public name: string,
        public values: string[] = [],
    ) {}
}

export class HibuTagDescription {
    constructor(
        public name: string,
        public values: string[], //TODO not used, supported tags actually have the fields name and description
    ) {}
}

export type CapabilityOption = {
    type: string,
    label: string,
    commandLabel: string,
}
